import React, {useContext} from 'react';

import Element from '~/src/components/element/Element';

import {classNameByType, classNames} from '~/src/utilities/helpers/css';
import {toPascalCase} from '~/src/utilities/helpers/string';
import {SettingsContext} from '~/src/components/context/SettingsContext';

import css from './InfoBox.module.scss';

const renderElement = (element, index) => {
    const className = classNameByType(css, element.type);

    return (
        <div key={index} className={className}>
            <Element {...element} />
        </div>
    );
};

const InfoBox = ({style = {}, ...props}) => {
    const {containerType} = style;
    const type = `type${toPascalCase(containerType || '_infobox_summary')}`;
    const {siteArea} = useContext(SettingsContext);
    const className = classNames(css, 'infoBox', siteArea, type);

    return (
        <div className={className} data-testid="InfoBox">
            {props.elements.map(renderElement)}
        </div>
    );
};

export default InfoBox;
